<template>
	<div class = "keyword-tag-group">
		<div
			class="modal fade keyword-tags"
			id="taggableKeyword"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Add Tags To Keyword(s)</h5>
					</div>
					<div class="modal-body" style ="padding-top :25px" v-if="isLoading">
						<div
						class="spinner-border"
						style="margin:40px auto;display:block;"
						></div>
					</div>
					<div class="modal-body main_form_block" style="margin-top:25px" v-else>
						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="tags"
								    :options="tagsList"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addTag"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Add Tags..."
								    class="form-control multi-dropdown col-md-12 select_filter"
								    :multiple="true"
								    id="keywordTags"
									:closeOnSelect="false"
										>
								</multiselect>
							</div>
						</div>
					</div>

					<div class="modal-footer">
						<div class="mt-2" style="text-align: center">
							<button type="button" @click="hideModal('cancel')" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
							<button
								type="button"
								class="btn btn-primary"
								@click = "saveTagsForKeyword()"
								>Save changes
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import Multiselect from "vue-multiselect";

	export default {
		name: "TagKeyword",
		components: {
			Multiselect
		},
		data() {
			return {
				tags:[],
				tagsList:[],
				isLoading: false
			};
		},
		mounted() {
			this.getTagsList()
		},
		computed:{
			keyWordToTagList: {
				get() {
					return this.$store.state.campaign.keyWordToTagList;
				},
				set(val) {
					this.$store.state.campaign.keyWordToTagList = val;
				}
			},
			actionSelectionControl: {
				set(val) {
					this.$store.state.campaign.actionSelectionControl = val
				},
				get() {
					return this.$store.state.campaign.actionSelectionControl
				}
			},
		},
		methods: {
			addTag(name){
				var pay = { title : name, id:''}
				if(this.tags){
					this.tags.push(pay)
				}
				else{
					this.tags = [];
					this.tags.push(pay)
				}
				this.tagsList.push(pay)
			},
			getTagsList(){
				let payload = {
					type:this.$route.params.sponsoredType =='sd'?'asin':'keyword'
				}
				let vm = this;
				this.$store.dispatch("campaign/getTagsForKeyword", payload).then((res) => {
					vm.tagsList = res
				})
			},
			hideModal(type,data){
				this.$emit("closeModal", type, data)
				this.tags = null;
				this.actionSelectionControl = false
			},
			saveTagsForKeyword(){
			//	const uniqueKeyword = [...new Set(this.keyWordToTagList.map(item => item.ams_keyword_id))];
				let resArr = [];
				if(this.$route.params.sponsoredType=='sd'){
					this.keyWordToTagList.filter(function(item){
				  	var i = resArr.findIndex(x => x.asin == item.asin);
					if(i <= -1){
						resArr.push(item);
					}
					return null;
					});
				}
				else if(this.$route.params.sponsoredType== 'sp' || this.$route.params.sponsoredType =='sb'){
					this.keyWordToTagList.filter(function(item){
					var i = resArr.findIndex(x => x.ams_keyword_id == item.ams_keyword_id);
					if(i <= -1){
						resArr.push(item);
					}
					return null;
					});
				}
				let payload  = {
					tags:this.tags,
					keywordList:resArr,
					type:(this.$route.params.sponsoredType=='sd')?'sd':'sp'
				}
				
				let vm = this
				this.isLoading = true
				this.$store.dispatch("campaign/saveKeywordTags", payload).then((res) => {
					vm.isLoading = false;
					vm.tagsList = [];
					vm.tags = []
					vm.hideModal('save',res);
					vm.actionSelectionControl = false
					vm.$store.dispatch("campaign/getCampaignList", {}).then(res => {
							console.log(res);
							vm.getTagsList();
					});
				})
			}
		}
	};
</script>

<style lang="scss">
.keyword-tags {
	.multiselect__tag{
		text-transform:none !important
	}
	.multiselect__single{
		text-transform: none !important;
		overflow: hidden;
	}
	.multiselect__option {
		span{
			text-transform: none !important;
		}
	}
}

</style>
